(function () {
  function initSizeChart(root) {
    if (!root || root.dataset.sizeChartReady === 'true') return;
    root.dataset.sizeChartReady = 'true';

    var openBtn = root.querySelector('[data-size-chart-open]');
    var portal = root.querySelector('[data-size-chart-portal]');
    var modal = root.querySelector('[data-size-chart-modal]');

    if (!openBtn || !portal || !modal) return;

    if (portal.parentElement !== document.body) {
      document.body.appendChild(portal);
    }

    function openModal() {
      portal.hidden = false;
      portal.setAttribute('data-open', 'true');
      document.documentElement.classList.add('size-chart-open');
      document.body.classList.add('size-chart-open');
      openBtn.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(function () {
        modal.focus({ preventScroll: true });
      });
    }

    function closeModal() {
      portal.hidden = true;
      portal.removeAttribute('data-open');
      document.documentElement.classList.remove('size-chart-open');
      document.body.classList.remove('size-chart-open');
      openBtn.setAttribute('aria-expanded', 'false');
    }

    openBtn.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });

    portal.querySelectorAll('[data-size-chart-close]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && portal.getAttribute('data-open') === 'true') {
        closeModal();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-size-chart]').forEach(initSizeChart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
